<template>
  <div class="location-progress-chart">
    <div class="chart-header">
      <h4 class="chart-title">Pathway Progress</h4>
      <div class="chart-actions">
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'bar' }"
          @click="selectedView = 'bar'"
          aria-label="Bar chart view"
        >
          <i class="fa fa-bar-chart" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'pie' }"
          @click="selectedView = 'pie'"
          aria-label="Pie chart view"
        >
          <i class="fa fa-pie-chart" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'list' }"
          @click="selectedView = 'list'"
          aria-label="List view"
        >
          <i class="fa fa-list" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="chart-action-btn"
          :class="{ active: selectedView === 'download' }"
          @click="selectedView = 'download', downFunc()"
          aria-label="Download chart"
        >
          <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="chart-content-area">
      <PathwayProgressBarChart
        v-if="selectedView === 'bar' || selectedView === 'download'"
        :menteeNames="menteeNames"
        :seriesValues="seriesValues"
        :seriesName="seriesName"
      />
      <PathwayProgressPieChart
        v-if="selectedView === 'pie'"
        :menteeNames="mentees"
        :seriesValues="seriesValues"
      />
      <PathwayProgressList
        v-if="selectedView === 'list'"
        :mentees="mentees"
        :menteeNames="menteeNames"
        :seriesValues="seriesValues"
      />
    </div>
  </div>
</template>
<script>
import PathwayProgressBarChart from '@/components/manager/pathway_progress_barchart.vue';
import PathwayProgressList from '@/components/manager/pathway_progress_list.vue';
import PathwayProgressPieChart from '@/components/manager/pathway_progress_piechart.vue';
import axios from 'axios';

export default {
  props: {
    menteeNames: {
      type: Array,
      default() {
        return [];
      },
    },
    seriesValues: {
      type: Array,
      default() {
        return [];
      },
    },
    seriesName: {
      type: String,
      default: 'Mentee Progress',
    },
    mentees: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedView: 'bar',
			apiUrl: process.env.API_ENDPOINT,
    };
  },
  components: {
    PathwayProgressBarChart,
    PathwayProgressList,
    PathwayProgressPieChart,
  },
	methods: {
		downFunc() {
      axios.get('/manager-pathway-progress-csv', {
        params: {
          accountId: this.$store.state.user_accountid,
        }
      })
			.then(response => {
				var fileName = response.data;
				if (fileName) {
					var url = this.apiUrl + '/custom/csv-view/' + fileName + '/Pathway-Progress';
					window.location.href = url;
				}
			})
			.catch(error => {

			});
		},
	},
};
</script>
<style scoped>
.location-progress-chart {
  width: 100%;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px 12px 8px 12px;
  border-bottom: 1px solid #e5e7eb;
}

.chart-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.1;
  color: #1f2937;
}

.chart-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 3px;
}

.chart-action-btn {
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #4b5563;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.chart-action-btn.active {
  color: #111827;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px #d1d5db;
}

.chart-action-btn i {
  font-size: 12px;
}

.chart-content-area {
  height: 100%;
  overflow: auto;
	margin-right: 20px;
	padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/pathway_progress_chart.vue